// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/styles.module.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/colors.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StatusToggleButton-module_fullwidth_qHty1,
.StatusToggleButton-module_fullwidth_qHty1 > span {
  display: block !important;
  height: 100%;
  text-align: center;
}

.StatusToggleButton-module_status_toggle_button_I6OG4 {
  margin-top: 28px;
}

.StatusToggleButton-module_deactivate_button_rBPmo {
  color: white !important;
}

.StatusToggleButton-module_deactivate_button_rBPmo span {
  color: white !important;
}

.StatusToggleButton-module_activate_button_HBogi {
  color: white !important;
}

.StatusToggleButton-module_activate_button_HBogi span {
  color: white !important;
}
`, "",{"version":3,"sources":["webpack://./src/client/components/Generic/Buttons/StatusToggleButton.module.css"],"names":[],"mappings":"AAAA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EAGE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EAGE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".fullwidth,\n.fullwidth > span {\n  display: block !important;\n  height: 100%;\n  text-align: center;\n}\n\n.status_toggle_button {\n  composes: bos_button from 'Styles/styles.module.css';\n  margin-top: 28px;\n}\n\n.deactivate_button {\n  composes: deactivate_status_background from 'Styles/colors.module.css';\n  composes: status_toggle_button;\n  color: white !important;\n}\n\n.deactivate_button span {\n  color: white !important;\n}\n\n.activate_button {\n  composes: active_status_background from 'Styles/colors.module.css';\n  composes: status_toggle_button;\n  color: white !important;\n}\n\n.activate_button span {\n  color: white !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fullwidth": `StatusToggleButton-module_fullwidth_qHty1`,
	"status_toggle_button": `StatusToggleButton-module_status_toggle_button_I6OG4 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bos_button"]}`,
	"deactivate_button": `StatusToggleButton-module_deactivate_button_rBPmo ${___CSS_LOADER_ICSS_IMPORT_1___.locals["deactivate_status_background"]} StatusToggleButton-module_status_toggle_button_I6OG4 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bos_button"]}`,
	"activate_button": `StatusToggleButton-module_activate_button_HBogi ${___CSS_LOADER_ICSS_IMPORT_1___.locals["active_status_background"]} StatusToggleButton-module_status_toggle_button_I6OG4 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bos_button"]}`
};
export default ___CSS_LOADER_EXPORT___;
